import axios from "axios";
import React from "react";
import { Link, useLoaderData } from "react-router-dom";

const TutorSubPaymentDetailsBkash = () => {
  const data = useLoaderData();
  console.log(data);

  const Invoice = data._id;
  const InvoiceId = Invoice;

  const handlePrint = () => {
    const printContents = document.getElementById("admissionForm").innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  const pay = async () => {
    try {
      const { data: responseData } = await axios.post(
        "https://tutor-tree-server-1.vercel.app/api/bkash/payment/create",
        {
          amount: data.inputData, // Use data.inputData as the amount
          orderId: 1,
          bkashInvoiceId: InvoiceId,
          bkashStudentJobId: data.StudentsJobID,
          teacherEmail: data.teacherEmail
        },
        { withCredentials: true }
      );
      window.location.href = responseData.bkashURL;
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const dateFormat = (dateString) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const date = new Date(dateString);
    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    return `${month} ${day}, ${year}`;
  };
  return (
    <div className="bg-white h-screen">
      <div className="w-full h-20 flex justify-start pl-5 items-center bg-green-500 shadow-md">
        <h2 className="text-xl text600 text-start text-white font-montserrat">
          All Invoice / Pending Payment
        </h2>
      </div>
      <div className="flex gap-5 items-center justify-start m-5">
        <Link to={`/dashboardTwo/AllInvoiceJobDetails/${data._id}`}>
          <h1 className="bg-green-700 text-white font-montserrat text-lg px-6 py-2 rounded">
            Job Details
          </h1>
        </Link>
        <button>
          <h1 className="bg-green-700 text-white font-montserrat text-lg px-6 py-2 rounded">
            Tutor Details
          </h1>
        </button>
      </div>
      <div className="px-10 py-5 border-2 border-green-500 rounded m-5">
        <div className="flex items-center justify-between py-5  border-b-4 border-green-500 border-dotted">
          <div className="flex flex-col">
            <div>
              <h1 className="text-md text600 font-montserrat text-green-900">
                Name : {data.teacherName}
              </h1>
            </div>
            <div>
              <h1 className="text-sm text500 font-montserrat text-green-900 mt-1">
                Email: {data.teacherEmail}
              </h1>
              <h1 className="text-sm text500 font-montserrat text-green-900 mt-1">
                Phone: {data.teacherPhone}
              </h1>
            </div>
          </div>
          <div>
            <h1 className="text-4xl font-bold font-marcellus">Tutor Tree</h1>
          </div>
        </div>
        <div className="flex items-center justify-between py-5">
          <div>
            <h1 className="text-lg font-montserrat text600 text-green-900 ">
              Invoice :{" "}
              <span className="text-md font-montserrat  text500 text-green-500">
                {InvoiceId}
              </span>
            </h1>
            <h1 className="text-lg font-montserrat text600 text-green-900 mt-3">
              Job Id :{" "}
              <span className="text-md font-montserrat  text500 text-green-500">
                {data.StudentsJobID}
              </span>
            </h1>
          </div>
          <div>
            <h1 className="text-lg  text600 text-green-900 font-montserrat mt-3">
              Class Start Date :{" "}
              <span className="text-md font-montserrat  text500 text-green-500">
                {dateFormat(data.startClassGreenDate)}
              </span>{" "}
            </h1>
            <h1 className="text-lg font-montserrat text600 text-green-900  mt-3">
              Class End Date :{" "}
              <span className="text-md font-montserrat  text500 text-green-500">
                {dateFormat(data.endClassGreenDate)}{" "}
              </span>{" "}
            </h1>
          </div>
        </div>
        <div className="flex items-center justify-between py-5 border-t-4 border-green-400 border-dashed">
          <div>
            <h1 className="text-xl font-bold font-montserrat text-green-900">
              Billed To :
            </h1>
            <h1 className="text-lg font-montserrat text500 text-green-900 uppercase mt-5">
              Name :{" "}
              <span className="text-lg font-montserrat text500 text-green-900 uppercase">
                {data.teacherName}
              </span>
            </h1>
            <h1 className="text-lg font-montserrat text500 text-green-900 uppercase mt-3">
              Address :{" "}
              <span className="text-lg font-montserrat text500 text-green-900">
                {data.teachercity} {data.teacherarea}
              </span>{" "}
            </h1>
            <h1 className="text-lg font-montserrat text500 text-green-900 uppercase mt-3">
              Phone :{" "}
              <span className="text-lg font-montserrat text500 text-green-900">
                {data.teacherPhone}
              </span>{" "}
            </h1>
          </div>
          <div className="w-[280px]">
            <h1 className="text-xl font-bold font-montserrat text-green-900">
              From
            </h1>
            <h1 className="text-lg font-montserrat text500 text-green-900 mt-5">
              Ademize Solutions
            </h1>
            <h1 className="text-lg font-montserrat text500 text-green-900 mt-3">
              Uttara, Dhaka
            </h1>
            <h1 className="text-lg font-montserrat text500 text-green-900 mt-3">
              ademize123@gmail.com
            </h1>
          </div>
        </div>
        <div class="mb-5 flex flex-col">
          <h1 className="text-lg font-montserrat font-bold text-green-500 mt-5 mr-3">
            Salary: {data.StudentsSalary} tk
          </h1>
          <h1 className="text-lg mt-6 font-montserrat font-bold text-green-600  mr-3">
            Commission to pay: {data.inputData} tk <span className="text-sm text-red-500 text500">(Every 5m pay 200tk more)</span>
          </h1>

          <button
            className="w-32 mt-5 py-2 font-montserrat text-lg text-white bg-green-700 rounded flex justify-center items-center"
            onClick={pay}
          >
            Pay bkash
          </button>
        </div>
      </div>
    </div>
  );
};

export default TutorSubPaymentDetailsBkash;
